/** @fileoverview Shared removable filter signifier built from the managed icon vocabulary. Parents own filter state and removal decisions. */
import React from 'react';
import AppIcon from './AppIcon';
import './AppControls.css';
export default function AppChip({ label, icon, removable, onRemove, className = '', style }) {
  return <span className={`app-chip ${className}`} style={style}>
    {icon && <AppIcon icon={icon} />}<span>{label}</span>
    {removable && <button type="button" aria-label={`Remove ${label}`} onClick={event => onRemove?.({ originalEvent: event, value: label })}><AppIcon icon="pi pi-times" /></button>}
  </span>;
}
